import { trackGAEvent } from "~/google_analytics/trackEvent";
import * as UserAnalytics from "~/google_analytics/user";

export function useGoogleAnalytics() {
    const auth = useAuth();

    const GoogleAnalyticsInit = () => {
        if (process.server) return; 

        if (auth?.access_token && auth?.user?.id) {
            UserAnalytics.setLoggedInUser({
                id: auth.user.id,
                email: auth.user.email || "",
                phone: auth.user.phone || 0
            });
        } else {
            UserAnalytics.setGuestUser();
        }
    };

    watch(
        () => auth?.access_token,
        () => {
            GoogleAnalyticsInit();
        },
        { immediate: true }
    );

    return {
        setGuestUser: UserAnalytics.setGuestUser,
        setLoggedInUser: UserAnalytics.setLoggedInUser,
        track: trackGAEvent,
        GoogleAnalyticsInit
    };
}
